import { FC } from "react";

import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IAPIError } from "shared/types";

import { getFields } from "./formData";

interface GuestlistBlockFormProps {
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  handleSubmit: (data: { title: string }) => void;
  apiStatus?: IAPIState | null;
  error?: string | boolean;
  apiError?: IAPIError | null;
  preventSubmit?: boolean;
  hideStatus?: boolean;
  disableType?: boolean;
  disableNbTickets?: boolean;
  submitMode?: "isDirty";
  hideTitle?: boolean;
}

export const GuestlistBlockForm: FC<GuestlistBlockFormProps> = ({
  defaultValues,
  buttons,
  handleSubmit,
  apiStatus,
  apiError,
  error,
  preventSubmit,
  hideStatus,
  submitMode,
  disableType,
  disableNbTickets,
  hideTitle,
  children,
}) => {
  return (
    <FormBuilder
      submitMode={submitMode}
      style={{ gridTemplateColumns: "1fr 1fr 1fr" }}
      fields={getFields({
        hideTitle,
        hideStatus,
        disableType,
        disableNbTickets,
      })}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
      buttons={buttons}
      isSubmitting={apiStatus === IAPIState.pending}
      apiErrorMessage={error}
      apiError={apiError}
      preventSubmit={preventSubmit}
    >
      {children}
    </FormBuilder>
  );
};
